<section class="container-fluid p-3">
  <div class="card p-2" *ngIf="product">
    <div class="row gx-4 gx-lg-5">
      <div class="col-md-5 position-relative">
        <app-image-container [images]="entity.images" [defaultImage]="product.defaultImage" [product]="product" *ngIf="product"></app-image-container>
      </div>
      <div class="col-md-7" >
        <div [ngClass]="{ 'disabledDiv': product.items[selectedItemIndex].availability < 1 }" [attr.disabled]="product.items[selectedItemIndex].availability < 1 ? '' : null">
          <h3 class="display-7 fw-bolder">{{ product.title }}</h3>
          <div class="small mb-1">Product Code: {{ product.items[selectedItemIndex].item_id }}
            <span class="text-danger" *ngIf="product.items[selectedItemIndex].partnerAvailability > 0">
              <img src="../../../../assets/images/edlong-old.png" alt="Delivery" width="120">
              by SmartDukaan
            </span>
            <span class="float-end me-md-3 "><p-chip class="text-lg" >{{product.items[selectedItemIndex].availability + ' Left in stock'}}</p-chip></span>
          </div>
          <div class="fs-5 mb-3 d-md-flex d-sm-block gap-1">
            <strong class="fs-3 fw-bold">
              <button class="btn variant-button btn-danger">{{calculateDiscount(product.items[selectedItemIndex]).percent}}</button>
              {{ (product.items[selectedItemIndex].mop - product.items[selectedItemIndex].cashback) | currency:"INR" }}
              <span class="fs-12 fw-lighter">Including all taxes</span>
              <br>
              <span class="fs-12 fw-lighter text-decoration-line-through mt-1">MRP: {{ product.items[selectedItemIndex].mrp.toFixed(2) | currency:"INR" }}</span>
              <br>
              <span *ngIf="product?.emiOptions?.length" class="fs-14 my-1">EMI starts from: {{ getLowestEMI(product.emiOptions) | currency:"INR" }}/month
              <a role="button" class="brand-color" (click)="op.toggle($event)">More</a></span>
            </strong>
          </div>
        </div>

        <div class="row">
          <div class="w-100 my-3" *ngIf="offers && offers.length">
            <p-carousel
              [value]="offers"
              [numVisible]="2"
              [numScroll]="1"
              [circular]="true"
              [responsiveOptions]="responsiveOptions"
              autoplayInterval="3000"
            >
              <ng-template let-offer pTemplate="offer">
                <div class="col-md-6 col-sm-12">
                  <div class="card h-100">
                    <div class="card-body">
                      <strong>{{offer.title}}</strong>
                      <p><small>{{ offer.detailedText }}</small></p>
                      <small class="text-muted">Expiring on : {{ offer.endDate | date }}</small>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-carousel>
          </div>
          <div class="col-md-6">
            <p class="mb-2 bold" *ngIf="product.items.length > 1">
              <a role="button"><i class="brand-color bold pi pi-tags"></i> Available Colors <i class="brand-color pi pi-angle-double-right"></i></a>
            </p>
            <div class="colors-section" *ngIf="product.items.length > 1">
              <button class="btn color-button {{product.items[selectedItemIndex].color == item.color ? 'btn-dark' : 'btn-outline-dark'}}" *ngFor="let item of product.items" (click)="selectColor(item)">{{item.color}}</button>
            </div>
          </div>
          <div class="col-md-6">
            <p class="mb-2 bold" *ngIf="product.superCatalogVariants.length > 1">
              <a role="button"><i class="brand-color bold pi pi-tags"></i> Storage <i class="brand-color pi pi-angle-double-right"></i></a>
            </p>
            <div class="colors-section" *ngIf="product.superCatalogVariants.length > 1">
              <button class="btn variant-button {{indx == selectedVariantIndex ? 'btn-dark' : 'btn-outline-dark'}}"
                      *ngFor="let variant of product.superCatalogVariants; let indx=index" (click)="selectVariant(indx)">{{variant.variantName}}</button>
            </div>
          </div>
        </div>

        <p class="mt-3 mb-3">{{ entity.warranty }}</p>

        <div class="warranty-panel" *ngIf="extendedWarranties.length">
          <p class="mt-3" *ngFor="let warranty of extendedWarranties; let wIndex = index">
            <input type="radio" name="extended" (click)="selectWarranty(wIndex)"><small class="fw-bold"> {{warranty.planName + ' at ₹'+warranty.premium + ' ('+warranty.duration+')' }}</small>
          </p>
        </div>

        <div class="d-flex gap-3 mt-2" [ngClass]="{ 'disabledDiv': product.items[selectedItemIndex].availability < 1 }" [attr.disabled]="product.items[selectedItemIndex].availability < 1 ? '' : null">
          <div class="d-flex align-items-center">
            <button class="btn btn-warning flex-shrink-0" type="button" (click)="addToCart()">
              <i class="pi pi-shopping-cart me-1 bold"></i> Add to cart
            </button>
          </div>
          <button class="btn btn-outline-danger w-full" (click)="buyNow()"><i class="pi pi-shopping-bag me-1 bold"></i> BuyNow</button>
        </div>

        <!--Key specification -->
        <div class="row">
          <div class="col-md-6" *ngIf="entity && entity.keySpecs.length > 1">
            <div class="mt-3">
              <p><i class="brand-color pi pi-key bold"></i> Key Specifications</p>
              <ul>
                <li *ngFor="let spec of entity.keySpecs">{{spec}}</li>
              </ul>
            </div>
          </div>
          <div class="col-md-6" *ngIf="entity && entity.packageContents.length > 1">
            <div class="mt-3">
              <p><i class="brand-color pi pi-box bold"></i> Package Contains</p>
              <ul>
                <li *ngFor="let content of entity.packageContents">{{content}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid p-3"  *ngIf="!productFound">
  <div class="alert alert-warning d-flex align-items-center justify-content-center flex-column text-center py-5" role="alert">
    <i class="pi pi-info-circle mb-3 text-danger" style="font-size: 4rem;"></i>
    <h4 class="fw-bold text-danger mb-2">Unable to fetch at this moment. <br>
    Try Again Later</h4>
  </div>
</div>

<!-- Related Items Section -->
<section *ngIf="product?.similarModels?.length">
    <h2 class="fw-bolder my-2 text-center">Related Products</h2>
    <p-carousel
      [value]="product.similarModels"
      [numVisible]="numVisible"
      [numScroll]="1"
      [showNavigators]="false"
      [responsiveOptions]="responsiveOptions"
    >
      <ng-template let-product pTemplate="item">
        <app-product [product]="product"></app-product>
      </ng-template>
    </p-carousel>
  </section>

<!--  Product Compare Section-->
<section class="container-fluid p-3" *ngIf="product?.compares && product?.compares?.length">
  <app-compare [products]="product.compares"></app-compare>
</section>

<!--  Other Details -->
<section class="container-fluid mb-5 py-md-1" *ngIf="product && entity.detailedSpecs.length">
  <app-specifications [specifications]="entity.detailedSpecs"></app-specifications>
</section>

<!-- Recently Viewed section -->
<section class="container-fluid mb-5" *ngIf="product?.recentlyViewed && product?.recentlyViewed?.length">
  <h2 class="fw-bolder mb-4 text-center">Recently Viewed</h2>
  <p-carousel
    *ngIf="product?.similarModels && product?.similarModels.length"
    [value]="product.recentlyViewed"
    [numVisible]="5"
    [numScroll]="1"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
    autoplayInterval="3000"
    [showNavigators]="false"
  >
    <ng-template let-product pTemplate="item">
      <app-product [product]="product"></app-product>
    </ng-template>
  </p-carousel>
</section>

<p-overlayPanel #op [style]="{ width: '360px' }" [showCloseIcon]="false">
  <ng-template pTemplate="content">
    <table class="table table-bordered">
      <tbody *ngFor="let issuer of product.emiOptions; let indx = index;">
        <tr>
          <!-- Accordion Header Row -->
          <td colspan="3" class="accordion-header bg-danger" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#' + issuer.issuerName.replace(' ', '-').toLowerCase()"
              (click)="issuerIndex = indx">
            <a role="button" class="fw-bold text-white">{{ issuer.issuerName }}</a>
          </td>
        </tr>
        <!-- Collapsible Row -->
        <tr [id]="issuer.issuerName.replace(' ', '-').toLowerCase()"
            class="accordion-collapse collapse"
            [class.show]="issuerIndex === indx">
          <td colspan="3">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>EMI Plan</th>
                <th>Interest</th>
                <th>Total Cost</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let option of issuer.listEmiTenure; let i = index"
                  (click)="selectedRowIndex = i"
                  [ngClass]="{'selected-row': selectedRowIndex === i}"
                  style="cursor: pointer;">
                <td>{{ (option.monthlyInstallment | currency:"INR") + 'x' + option.tenureInMonth + 'm' }}</td>
                <td>{{ option.bankInterestRate / 100 }}%</td>
                <td>{{ (option.loanAmount + option.interestPayToBank) | currency:"INR" }}</td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!--<ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation" *ngFor="let issuer of product.emiOptions; let indx = index;">
        <button
          class="nav-link"
          [class.active]="issuerIndex === indx"
          id="{{issuer.issuerName.replaceAll(' ','-') | lowercase}}-tab"
          data-bs-toggle="tab"
          data-bs-target="#{{issuer.issuerName.replaceAll(' ','-') | lowercase}}"
          type="button"
          role="tab"
          aria-controls="{{issuer.issuerName | lowercase}}"
          aria-selected="{{issuerIndex === indx}}"
          (click)="issuerIndex = indx; selectedRowIndex = null">
          {{ issuer.issuerName }}
        </button>
      </li>
    </ul>
    <div class="tab-content text-center" id="myTabContent">
      <div *ngFor="let issuer of product.emiOptions; let indx = index;"
           class="tab-pane fade"
           [class.show]="issuerIndex === indx"
           [class.active]="issuerIndex === indx"
           id="{{issuer.issuerName.replaceAll(' ','-') | lowercase}}"
           role="tabpanel"
           aria-labelledby="{{issuer.issuerName.replaceAll(' ','-') | lowercase}}-tab"
           (click)="issuerIndex = indx">
        <table class="table table-bordered border">
          <tr>
            <th>EMI Plan</th>
            <th>Interest</th>
            <th>Total Cost</th>
          </tr>
          <tr *ngFor="let option of issuer.listEmiTenure; let i = index" (click)="selectedRowIndex = i" [ngClass]="{'selected-row': selectedRowIndex === i}" style="cursor: pointer;">
            <td>{{(option.monthlyInstallment | currency:"INR")+'x'+option.tenureInMonth+'m'}}</td>
            <td>{{option.bankInterestRate/100}}%</td>
            <td>{{option.loanAmount + option.interestPayToBank | currency:"INR"}}</td>
          </tr>
        </table>
        &lt;!&ndash;<button class="btn btn-primary" *ngIf="selectedRowIndex != null">Choose this plan</button>&ndash;&gt;
      </div>
    </div>-->
  </ng-template>
</p-overlayPanel>
